import { ScoredCreditCardProduct } from '@appTypes/EligibilityApi.interface'

export function getCardApr(card: ScoredCreditCardProduct) {
    return card.guaranteedRate?.guaranteedAPR != null
        ? card.guaranteedRate.guaranteedAPR.toFixed(1)
        : card.offerDetail.representativeAPR
}
